exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oi-donation-form .header{text-align:center;font-size:20px;padding:5px 10px!important}", ""]);

// exports
